import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af9775c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-tenant-header d-flex align-items-center" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "fs-5 fw-bolder rating-text" }
const _hoisted_7 = {
  class: "d-flex",
  style: {"margin-top":"6px"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-flex align-items-center sub-info" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-user icon" }),
  /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Tenant")
], -1))
const _hoisted_9 = { class: "d-flex align-items-center sub-info" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-phone icon" }, null, -1))
const _hoisted_11 = { class: "text" }
const _hoisted_12 = { class: "d-flex align-items-center sub-info" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-envelope icon" }, null, -1))
const _hoisted_14 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Avatar, {
      src: _ctx.avatarSrc,
      width: "64px",
      height: "64px"
    }, null, 8, ["src"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.fullName), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form_item, { class: "mb-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_rate, {
                disabled: "",
                size: "small",
                class: "rating-size",
                "model-value": parseFloat(_ctx.averageRating)
              }, null, 8, ["model-value"])
            ]),
            _: 1
          }),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.rate) + "/5.0 ", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("span", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.info?.mobile_number), 1)
        ]),
        _createElementVNode("span", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.info?.email), 1)
        ])
      ])
    ])
  ]))
}